<template>
  <div class="headerContainer">
    <img src="../assets/lyLogo.jpg" style="width:70px;height:70px" />
    <img src="../assets/txlLogo.jpg" style="width:70px;height:70px" />
    <div class="headerTitle">厦门力元工贸有限公司 信息管理系统</div>
    <!-- <img src="../assets/bgimg3.jpg" style="width:70px;height:70px" />
    <img src="../assets/bgimg3.jpg" style="width:70px;height:70px" />
    <div class="headerTitle">厦门XXX有限公司 物流管理系统</div> -->
    <div style="position:absolute;right:60px">
      <el-dropdown @command="clickItem" trigger="click" placement="bottom">
        <span class="el-dropdown-link">用户: {{$store.state.accountName}}</span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="changePassword">修改密码</el-dropdown-item>
          <el-dropdown-item command="loginout" style="text-align:center">退出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <!-- 修改密码对话框 -->
    <el-dialog title="修改密码" :visible.sync="passwordDialog" width="500px">
    <el-form :rules="rules" :model="form" ref="form" label-width="110px" style="width:300px;margin:auto;">
      <el-form-item prop="oldPassword" label="旧密码">
        <el-input type="password" size="small" v-model="form.oldPassword" style="width:180px" show-password></el-input>
      </el-form-item>
      <el-form-item prop="newPassword" label="新密码">
        <el-input type="password" size="small" v-model="form.newPassword" style="width:180px" show-password></el-input>
      </el-form-item>
      <el-form-item prop="checkNewPassword" label="确认新密码">
        <el-input type="password" size="small" v-model="form.checkNewPassword" style="width:180px" show-password></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="passwordDialog = false">取 消</el-button>
      <el-button type="primary" @click="doChangePassword">确 定</el-button>
    </span>
  </el-dialog>
  </div>
</template>

<script>
import { changePassword } from '../api/index'
import { getEncryptionPassword } from '../assets/lib/utils'
export default {
  data () {
    return {
      passwordDialog: false,
      form: {
        oldPassword: '',
        newPassword: '',
        checkNewPassword: ''
      },
      rules: {
        oldPassword: [
          { required: true, message: '请输入旧密码', trigger: 'blur' },
          { pattern: /^.{6,18}$/, message: '密码应在6~18个字符之间', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { pattern: /^.{6,18}$/, message: '密码应在6~18个字符之间', trigger: 'blur' }
        ],
        checkNewPassword: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { pattern: /^.{6,18}$/, message: '密码应在6~18个字符之间', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    clickItem (command) {
      if (command === 'loginout') {
        localStorage.removeItem('token')
        this.$router.replace({
          path: '/login'
        })
      } else if (command === 'changePassword') {
        // TODO
        this.passwordDialog = true
      }
    },
    doChangePassword () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          if (this.form.newPassword !== this.form.checkNewPassword) {
            this.$message.error('新密码两次输入不一致')
          } else {
            changePassword({
              oldPassword: getEncryptionPassword(this.$store.state.username, this.form.oldPassword),
              newPassword: getEncryptionPassword(this.$store.state.username, this.form.newPassword)
            }).then(res => {
              if (res.data.status === 200) {
                this.$message.success(res.data.msg)
                localStorage.removeItem('token')
                setTimeout(() => {
                  this.$router.push('/login')
                }, 1000)
              } else {
                this.$message.error(res.data.msg)
              }
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.headerContainer {
  display: flex;
  align-items: center;
  position: relative;
  /* justify-content: space-around; */
}
.headerTitle {
  padding-left: 15px;
  font-size: 22px;
  color: #ffffff;
}
.el-dropdown-link {
  color: #fff;
  cursor: pointer;
}
</style>
<style>
.el-dropdown-menu {
  top: 40px !important;
}
</style>
